import React from 'react';
import { useNavigate } from 'react-router-dom';

function AdminHeader({ user, onLogout }) {
  const navigate = useNavigate();

  return (
    <div className="admin-header">
      <div className="admin-header-content">
        <div className="admin-header-left">
          <div className="admin-logo" style={{display: 'flex', alignItems: 'center'}}>
            <img 
              src="/logo.png" 
              alt="Loom Logo" 
              style={{height: '50px', width: 'auto', maxWidth: '150px'}}
            />
          </div>
        </div>
        
        <div className="admin-header-right">
          <div className="admin-user-info">
            <div className="admin-user-avatar">
              {user?.name?.charAt(0).toUpperCase() || 'A'}
            </div>
            <div className="admin-user-details">
              <span className="admin-user-name">{user?.name || 'Admin'}</span>
              <span className="admin-user-role">Administrator</span>
            </div>
          </div>
          
          <button className="admin-logout-btn" onClick={onLogout}>
            <span>🚪</span>
            Logout
          </button>
        </div>
      </div>
    </div>
  );
}

export default AdminHeader;
